var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpathy = function SvgEmpathy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#empathy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.305 4.35 16.07 6.387l-3.889 8.1a1 1 0 0 0 .902 1.434h5.555a1 1 0 0 1 .956 1.294l-3.953 12.81 13.695-14.104a7.864 7.864 0 0 0 1.956-9.495A8.16 8.16 0 0 0 18.305 4.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.373 15.66 15.64 30.026l3.953-12.81a1 1 0 0 0-.956-1.295h-5.555a1 1 0 0 1-.902-1.431l3.89-8.1-2.237-2.04A8.16 8.16 0 0 0 .855 6.426a7.92 7.92 0 0 0 1.518 9.233Z",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empathy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgEmpathy;